export default __webpack_public_path__ + "assets/images/baaff04eb105397251c7642b48378db6.svg";